




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { VDialog } from 'vuetify/lib'
import { CartItemInterface } from '../../interfaces/CartItem.interface'
import { AttributeInterface } from '../../interfaces/Attribute.interface'
import { CartInterface } from '../../interfaces/Cart.interface'

declare global {
  interface Window {
    storeSettings: any
    aspenwareDataLayer: any
  }
}
@Component({
  name: 'ResortOsToast',
  extends: VDialog,
})
export default class ResortOsToast extends Vue {
  private vpWidth: number | null = null
  private isShowDialog: boolean = false
  private checkingOut: boolean = false
  private storeEl: HTMLElement | null = null
  @Getter('global/hiddenAttributes') hiddenAttributes
  @Prop({ default: false }) dialog: boolean
  @Prop({ default: null }) product: CartItemInterface | null
  @Prop({ default: null }) quantity: string | null
  @Prop({ default: false }) isEditedProduct: boolean
  mounted() {
    this.setWindowSize()
    this.initListeners()
    this.storeEl = document.querySelectorAll('html')[0]
    this.storeEl.classList.add('resort-os')
  }
  beforeUnmount() {
    this.removeListeners()
  }

  private activateCSS() {
    if (this.storeEl) {
      this.storeEl.classList.add('resort-os--toast')
    }
  }
  private deactivateCSS() {
    if (this.storeEl) {
      setTimeout(() => {
        this.storeEl?.classList.remove('resort-os--toast')
      }, 200)
    }
    const commerceEl = document.getElementById('commerce-store')
    if (commerceEl) {
      commerceEl.classList.remove('mini-cart-open')
    }
  }
  private initListeners(): void {
    window.addEventListener('resize', this.setWindowSize)
  }
  private removeListeners(): void {
    window.removeEventListener('resize', this.setWindowSize)
  }
  private setWindowSize(): void {
    this.vpWidth = window.innerWidth
  }
  private closeDialog(): void {
    this.$emit('close-dialog')
  }
  private currencyToNumber(currency: string): number {
    const aNumber = Number(currency.replace(/[^0-9\.-]+/g, ''))
    return aNumber
  }
  private viewCart(): void {
    window.location.assign('/cart')
  }
  private checkOut(): void {
    this.checkingOut = true
        this.sendGA4BeginCheckoutEvent()
  }

  private sendGA4BeginCheckoutEvent(): void {
    const cart = this.cart
    const products = cart.Items.map((item) => {
      return {
        item_id: item.ProductId,
        item_name: item.ProductName,
        item_brand: item.ProductName,
        item_category: item.ProductName,
        item_variant: item.ProductName,
        price: this.currencyToNumber(item.UnitPrice || ''),
        quantity: item.Quantity,
      }
    })

    window.aspenwareDataLayer.push({
      event: 'begin_checkout',
      currency: window.storeSettings.CurrencyCode,
      value: this.currencyToNumber(cart.SubTotal || ''),
      aspenware_platform: 'aspenware_commerce',
      aspenware_version: window.storeSettings.Store.AspenwareVersion,
      ecommerce: {
        items: products,
      },
    })
    window.location.assign('/onepagecheckout')
  }
  private isValidDate(val: string): boolean {
    const date = new Date(val)
    return date instanceof Date && !isNaN(Number(date))
  }

  get transitionType(): string {
    return this.isDesktop ? 'fade-transition' : 'slide-y-reverse-transition'
  }
  get cart(): CartInterface {
    return this.$store.getters['cart/cart']
  }
  get subTotal(): string {
    return this.cart ? this.cart.SubTotal : ''
  }
  get storeSettings(): any {
    return window.storeSettings
  }
  get attributes(): AttributeInterface[] | undefined {
    return this.product?.Attributes
  }
  get attributesToDisplay(): AttributeInterface[] | undefined {
    if (this.attributes) {
      const filteredAttributes = this.attributes.filter((item) => {
        return this.hiddenAttributes.indexOf(item.name) == -1
      })
      return filteredAttributes
    }
    return undefined
  }
  get attributeString(): string {
    if (!this.product || !this.attributesToDisplay) {
      return ''
    }
    let list = ''

    this.attributesToDisplay.forEach((attribute, index) => {
      const attributeValue = attribute.value
      const isDate = this.isValidDate(attributeValue)
      if (!isDate && attributeValue) {
        list += `${attributeValue}`
      }
      if (isDate) {
        const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' }
        const date = new Date(attributeValue)
        const formattedDate = date.toLocaleDateString(this.storeSettings.Locale, options)
        list += `${formattedDate}`
      }
      if (
        this.attributesToDisplay &&
        this.attributesToDisplay.length > 1 &&
        index !== this.attributesToDisplay.length - 1
      ) {
        list += ', '
      }
    })
    return list
  }
  get hasDiscount(): boolean | undefined {
    return this.product?.DiscountInfo ? this.product.DiscountInfo.Discounts.length > 0 : false
  }
  get discountMessage(): string {
    return this.storeSettings?.Labels?.ShoppingCart?.ToastDiscountMessage || ''
  }
  get showDiscountMessage(): boolean {
    return this.storeSettings?.ShoppingCartSettings?.ShowDiscountBox || false
  }
  get itemEditedMessage(): string {
    return this.storeSettings?.Labels?.ShoppingCart?.ItemUpdated || 'Item Changed'
  }
  get hasSavings(): boolean {
    if (!this.product) {
      return false
    }
    const originalPrice = this.currencyToNumber(this.product.OriginalPrice)
    const newPrice = this.currencyToNumber(this.product.UnitPrice)
    return newPrice < originalPrice
  }
  get unitPrice(): string {
    return this.product ? this.product.UnitPrice : ''
  }
  get originalPrice() {
    return this.product ? this.product.OriginalPrice : ''
  }
  get productName(): string {
    return this.product ? this.product.ProductName : ''
  }
  get productQuantityAdded(): string {
    return `(${this.quantity})`
  }
  get cartQuantity(): string {
    if (!this.cart) {
      return ''
    }
    return `(${this.cart.TotalProducts})`
  }
  get isDesktop(): boolean | null {
    if (!this.vpWidth) {
      return null
    }
    return this.vpWidth > 735 ? true : false
  }
  get showDialog(): boolean {
    this.isShowDialog = this.dialog
    return this.isShowDialog
  }

  @Watch('showDialog')
  onShowDialog(newValue) {
    if (newValue === true) {
      this.activateCSS()
    } else {
      this.deactivateCSS()
    }
  }
}
